var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AbstractEditable from './abstract';
var TextEditable = /** @class */ (function (_super) {
    __extends(TextEditable, _super);
    function TextEditable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEditable.prototype.render = function () {
        var _this = this;
        if (this._args.hasOwnProperty('html_attributes') && this._args.html_attributes.hasOwnProperty('type')) {
            this.getElement().classList.add("-input-" + this._args.html_attributes.type);
        }
        setTimeout(function () {
            _this.getElement().querySelector('input').focus();
        }, 0);
    };
    TextEditable.prototype.valueToInput = function (value) {
        if (!value) {
            return;
        }
        this.getElement().querySelector('input').value = value;
    };
    TextEditable.prototype.getValue = function () {
        return this.getElement().querySelector('input').value;
    };
    TextEditable.prototype.getTemplate = function () {
        return this._template.form.input('input', null, this._args.html_attributes).outerHTML;
    };
    TextEditable.prototype._setDefaults = function () {
        this._defaults.type = 'text';
    };
    return TextEditable;
}(AbstractEditable));
export default TextEditable;
